import { cn } from "@/lib/utils";

export function AndroidIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[15px] w-[13px] text-mint", className)}
      viewBox="0 0 13 15"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.634 8.983c.464 0 .84.386.84.862v3.696a.851.851 0 01-.84.861.851.851 0 01-.841-.861V9.845c0-.476.376-.862.84-.862z"
        fill="currentColor"
      />
      <path
        d="M2.715 4.54a1.167 1.167 0 00-.005.098v5.6c0 .603.465 1.088 1.042 1.088h5.556c.578 0 1.043-.485 1.043-1.088v-5.6c0-.033-.002-.066-.004-.099H2.715z"
        fill="currentColor"
      />
      <path
        d="M8.425 8.983a.85.85 0 01.84.862v3.696a.851.851 0 01-.84.861.851.851 0 01-.84-.861V9.845c0-.476.376-.862.84-.862zM1.358 5.037c.464 0 .84.386.84.862v3.696a.851.851 0 01-.84.862.851.851 0 01-.84-.862V5.9c0-.476.376-.862.84-.862zm10.342 0c.464 0 .84.386.84.862v3.696a.851.851 0 01-.84.862.851.851 0 01-.84-.862V5.9c0-.476.376-.862.84-.862zm-8.96-.866c.023-1.72 1.488-3.13 3.368-3.317h.845c1.88.186 3.344 1.597 3.368 3.317H2.739z"
        fill="currentColor"
      />
      <path
        d="M10.028.688L9.14 2.263M3.031.688l.887 1.575L3.031.688z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.657"
      />
      <path
        d="M5.401 2.63a.435.435 0 11-.87.002v-.003a.435.435 0 11.87-.002v.002zm3.246 0a.435.435 0 11-.87.002v-.003a.435.435 0 11.87-.002v.002z"
        fill="#fff"
      />
    </svg>
  );
}

export function CloudIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-8 w-40.5 text-deep-violet", className)}
      viewBox="0 0 162 32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M149.671 29.067c6.428-4.678 10.714 0 12.054 2.923H0C6.34 8.046 36.659 7.681 44.934 18.16c16.92-26.349 49.152-20.508 56.52-4.684 12.858-3.897 18.751 4.223 20.09 8.77 15.269-9.354 25.113.65 28.127 6.82z"
        fill="currentColor"
      />
    </svg>
  );
}
